import React, { useEffect, useState } from 'react';
import { Button, Input, InputNumber, Modal, Select, Table } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { hooks, models } from '@vote4dance/judging-sdk';
var RoundItem = models.rounds.RoundItem;
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
var ClassItem = models.classes.ClassItem;
import { DeleteOutlined } from '@ant-design/icons';
import { sanitizeRoundPriorityGroups } from '../utilities';
export const RoundPrioritySettings = (props) => {
    const { item, list, open, disabled, onClose, onValue } = props;
    const [groups, setGroups] = useState([]);
    useEffect(() => {
        resetSettings();
    }, [list]);
    const resetSettings = () => {
        const sanitizedGroups = sanitizeRoundPriorityGroups(list, { preferMax: true });
        setGroups(sanitizedGroups.map((group) => ({ ...group, key: Math.random().toString() })));
    };
    const handleClose = () => {
        resetSettings();
        onClose();
    };
    const handleSave = () => {
        const newList = [...groups];
        newList.forEach((group) => delete group.key);
        onValue(newList);
        onClose();
    };
    return (React.createElement(Modal, { title: _T('round.details.round_priority_settings.label'), open: open, okText: _T('common.ok'), cancelText: _T('common.cancel.title'), onCancel: handleClose, onOk: handleSave, okButtonProps: { disabled: disabled }, width: 1000 },
        React.createElement(RoundPriorityTable, { item: item, groups: groups, disabled: disabled, allowChange: true, setGroups: groups => setGroups(groups) })));
};
export const RoundPriorityTable = (props) => {
    const { item, groups, disabled, allowChange, setGroups } = props;
    const [classes, loadingClasses] = Stream(ClassesSource(item.competition_id));
    const [maxSettingsReached, setMaxSettingsReached] = useState(false);
    useEffect(() => {
        setMaxSettingsReached(groups.filter(group => group.max !== undefined || group.percentage !== undefined).length == groups.length - 1);
    }, [groups]);
    const updateSetting = (index, attribute, value) => {
        const newList = [...groups];
        const newGroup = {
            ...newList[index],
            [attribute]: value
        };
        if (value === null || (value === null || value === void 0 ? void 0 : value.length) === 0) {
            delete newGroup[attribute];
        }
        if (attribute === 'percentage' && value != null && value !== '') {
            delete newGroup.max;
        }
        if (attribute === 'max' && value != null && value !== '') {
            delete newGroup.percentage;
        }
        newList[index] = newGroup;
        setGroups(newList);
    };
    const onAddRow = () => {
        const newList = [...groups];
        newList.push({
            key: Math.random().toString()
        });
        setGroups(newList);
    };
    const onDeleteRow = (index) => {
        const newList = [...groups];
        newList.splice(index, 1);
        setGroups(newList);
    };
    const columns = [
        {
            title: _T('round.details.class_label.label'),
            dataIndex: 'class_id',
            key: 'class_id',
            hidden: !allowChange,
            render: (_text, group, index) => (React.createElement(Select, { value: group.class_id, placeholder: _T('class.title'), style: { width: '100%', minWidth: 150 }, allowClear: true, onChange: value => updateSetting(index, 'class_id', value) }, classes && classes.map(classItem => React.createElement(Select.Option, { value: classItem.class_id, key: classItem.class_id }, ClassItem.getClassLabel(classItem)))))
        },
        RoundItem.isPointSummary(item) ? [
            {
                title: _T('round.details.round_priority_settings.group.points'),
                dataIndex: 'points',
                key: 'points',
                disabled: disabled || !allowChange,
                render: (_text, group, index) => (React.createElement(InputNumber, { value: group.points, onChange: value => updateSetting(index, 'points', value) }))
            },
            {
                title: _T('round.details.round_priority_settings.group.multiplier'),
                dataIndex: 'multiplier',
                key: 'multiplier',
                disabled: disabled || !allowChange,
                render: (_text, group, index) => (React.createElement(InputNumber, { value: group.multiplier, step: 0.1, onChange: value => updateSetting(index, 'multiplier', value) }))
            }
        ] : [,
            {
                title: _T('common.name'),
                dataIndex: 'name',
                key: 'name',
                disabled: disabled || !allowChange,
                render: (_text, group, index) => (React.createElement(Input, { value: group.name, onChange: e => updateSetting(index, 'name', e.target.value), disabled: disabled || !allowChange }))
            },
            {
                title: _T('round.details.round_priority_settings.group.percentage'),
                dataIndex: 'percentage',
                key: 'percentage',
                render: (_text, group, index) => (React.createElement(InputNumber, { value: group.percentage, onChange: value => updateSetting(index, 'percentage', value), placeholder: _T('classrules.details.round_num_through.percent'), disabled: disabled || group.max !== undefined || (maxSettingsReached && !(group.max !== undefined || group.percentage !== undefined)) }))
            },
            {
                title: _T('common.max'),
                dataIndex: 'max',
                key: 'max',
                render: (_text, group, index) => (React.createElement(InputNumber, { value: group.max, onChange: value => updateSetting(index, 'max', value), placeholder: _T('classrules.details.round_num_through.count'), disabled: disabled || group.percentage !== undefined || (maxSettingsReached && !(group.max !== undefined || group.percentage !== undefined)) }))
            }],
        {
            key: 'delete',
            hidden: !allowChange,
            render: (text, _, index) => (React.createElement(Button, null,
                React.createElement(DeleteOutlined, { onClick: () => onDeleteRow(index) })))
        }
    ].flat().filter((column) => Object.keys(column).length > 0);
    const footer = () => React.createElement(Button, { onClick: onAddRow }, _T('common.add'));
    return (React.createElement(Table, { loading: loadingClasses, dataSource: groups, columns: columns, pagination: false, footer: allowChange ? footer : undefined }));
};
